import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

const revokeZoomAccess = async (): Promise<void> => {
  const res = await fetchOrchidAPI(`/api/users/v1/zoom/revoke_access`, {
    method: "POST",
  });

  if (!res.ok) {
    const responseText = await res.text();
    throw new Error(
      `Failed to revoke Zoom access: ${getErrorDetail(responseText)}`,
    );
  }

  return;
};

export default revokeZoomAccess;
